import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";
    
Vue.config.productionTip = false
var firebaseConfig = {
  apiKey: "AIzaSyAdX60kTflLUn0Ll_pYN0uhMpQDFBRj3vs",
  authDomain: "csmutiara-53e95.firebaseapp.com",
  databaseURL: "https://csmutiara-53e95.firebaseio.com",
  projectId: "csmutiara-53e95",
  storageBucket: "csmutiara-53e95.appspot.com",
  messagingSenderId: "264198948482",
  appId: "1:264198948482:web:a57aeb7958bdee5baed69b",
  measurementId: "G-56C896FDJZ"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
// alias
Vue.prototype.$analytics = firebase.analytics();
new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
